import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { Tabs, Tab } from 'react-bootstrap-tabs'
import { graphql, compose } from 'react-apollo'
import moment from 'moment'
import Modal from 'react-bootstrap-modal'
import AcceptModal from '../Modals/AcceptModal'
import SummaryModal from '../Modals/SummaryModal'
import PriceModal from '../Modals/PriceModal'
import { translate } from 'react-i18next'

import CUSTOMIZED_PLAN_QUERY from '../../../../graphql/CustomizedPlan.graphql'

class TripGuruOrders extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      activeTab: 0
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      (!this.props.user && !nextProps.loading && !nextProps.user) ||
      (nextProps.user && !nextProps.user.userRoles.map(({ role }) => role).includes('Guru'))
    ) {
      this.props.history.push('/')
    }
  }

  openAcceptModal(index, arr) {
    this.setState({
      order: arr[index],
      acceptOpen: true
    })
  }

  openSummaryModal(index, arr) {
    this.setState({
      order: arr[index],
      summaryOpen: true,
      activeTab: this.state.activeTab
    })
  }

  openPriceModal(index, arr) {
    this.setState({
      order: arr[index],
      priceOpen: true
    })
  }

  goToTab(tab) {
    this.setState({
      activeTab: tab
    })
  }

  closeModal() {
    this.setState({
      acceptOpen: false,
      summaryOpen: false,
      priceOpen: false
    })
  }

  render() {
    const { t, user } = this.props
    const allCustomizedPlans = this.props.data.allCustomizedPlans || []
    const completed = allCustomizedPlans.filter(plan => {
      let startDate = moment(plan.startDate).format('YYYY-MM-DD')
      return plan.orderStatus === 'Declined' || moment(startDate).isBefore(moment().format('YYYY-MM-DD'))
    })

    const future = allCustomizedPlans.filter(plan => {
      let startDate = moment(plan.startDate).format('YYYY-MM-DD')
      return plan.orderStatus !== 'Declined' && moment(startDate).isSameOrAfter(moment().format('YYYY-MM-DD'))
    })

    console.log('orders', this.props)

    return (
      <div className={user ? 'container' : 'hidden'}>
        <Tabs className="orders" selected={this.state.activeTab} onSelect={index => this.goToTab(index)}>
          <Tab label={t('future_orders')}>
            <div className={future.length ? '' : 'hidden'}>
              <table className="table">
                <thead>
                  <tr>
                    <th className="col-lg-2 col-md-2 col-sm-2 col-xs-2">{t('status')}</th>
                    <th className="col-lg-2 col-md-2 col-sm-2 col-xs-2">{t('action')}</th>
                    <th className="col-lg-1 col-md-1 col-sm-1">{t('type')}</th>
                    <th className="col-lg-3 col-md-3 col-sm-3">{t('details')}</th>
                    <th className="col-lg-2 col-md-2 col-sm-2">{t('pay_by')}</th>
                    <th className="col-lg-1 col-md-1 col-sm-2">{t('amount')}</th>
                    <th className="col-lg-1 col-md-1 col-sm-2">{t('date')}</th>
                  </tr>
                </thead>
                <tbody>
                  {future.map((plan, index) => (
                    <tr key={plan.id}>
                      <td>{t(plan.orderStatus.toLowerCase())}</td>
                      <td>
                        <button
                          className={plan.orderStatus === 'NewOrder' ? 'order-action' : 'hidden'}
                          onClick={() => this.openAcceptModal(index, future)}
                        >
                          {t('approve_decline')}
                        </button>
                        <button
                          className={plan.orderStatus === 'Approved' ? 'order-action' : 'hidden'}
                          onClick={() => this.openPriceModal(index, future)}
                        >
                          {t('changeprice')}
                        </button>
                        <span
                          className={
                            plan.orderStatus === 'Declined' || plan.orderStatus === 'Charged' || plan.orderStatus === 'ChangePrice'
                              ? ''
                              : 'hidden'
                          }
                        >
                          {t('no_action')}
                        </span>
                      </td>
                      <td>Trip Guru</td>
                      <td onClick={() => this.openSummaryModal(index, future)}>
                        {plan.planLocations.length ? plan.numDays + ' days in ' : ''}
                        {plan.planLocations.length
                          ? plan.planLocations.map((location, index) => {
                              if (index !== plan.planLocations.length - 1) {
                                return location.country + ', '
                              } else {
                                return location.country
                              }
                            })
                          : ''}
                      </td>
                      <td>
                        {plan.orderingUser ? plan.orderingUser.userProfile.firstName + ' ' + plan.orderingUser.userProfile.lastName : ''}
                      </td>
                      <td>{'$' + (plan.totalAmount + plan.servicesTotal)}</td>
                      <td>
                        {plan.startDate
                          ? this.props.i18n.t('date_format', {
                              date: plan.startDate
                            })
                          : ''}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <table className="table">
                <tbody>
                  <tr>
                    <td className="col-lg-2 col-md-2 col-sm-2 col-xs-2" />
                    <td className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                      <div className="arrow-wrapper">
                        <i className="icon-arrow-previous-1" onClick={() => this.goToTab(0)} />
                        <i className="icon-arrow-next-1" onClick={() => this.goToTab(1)} />
                      </div>
                    </td>
                    <td className="col-lg-1 col-md-1 col-sm-1" />
                    <td className="col-lg-3 col-md-3 col-sm-3" />
                    <td className="col-lg-2 col-md-2 col-sm-2" />
                    <td className="col-lg-1 col-md-1 col-sm-2" />
                    <td className="col-lg-1 col-md-1 col-sm-2" />
                  </tr>
                </tbody>
              </table>
            </div>
          </Tab>
          <Tab label={t('completed_orders')}>
            <div className={completed.length ? '' : 'hidden'}>
              <table className="table">
                <thead>
                  <tr>
                    <th className="col-lg-2 col-md-2 col-sm-2 col-xs-2">{t('status')}</th>
                    <th className="col-lg-2 col-md-2 col-sm-2 col-xs-2">{t('action')}</th>
                    <th className="col-lg-1 col-md-1 col-sm-1">{t('type')}</th>
                    <th className="col-lg-3 col-md-3 col-sm-3">{t('details')}</th>
                    <th className="col-lg-2 col-md-2 col-sm-2">{t('pay_by')}</th>
                    <th className="col-lg-1 col-md-1 col-sm-2">{t('amount')}</th>
                    <th className="col-lg-1 col-md-1 col-sm-2">{t('date')}</th>
                  </tr>
                </thead>
                <tbody>
                  {completed.map((plan, index) => (
                    <tr key={plan.id}>
                      <td>{t(plan.orderStatus.toLowerCase())}</td>
                      <td>
                        <button
                          className={plan.orderStatus === 'NewOrder' ? 'order-action' : 'hidden'}
                          onClick={() => this.openAcceptModal(index, completed)}
                        >
                          {t('approve_decline')}
                        </button>
                        <button
                          className={plan.orderStatus === 'Approved' ? 'order-action' : 'hidden'}
                          onClick={() => this.openPriceModal(index, completed)}
                        >
                          {t('changeprice')}
                        </button>
                        <span className={plan.orderStatus === 'Declined' || plan.orderStatus === 'ChangePrice' ? '' : 'hidden'}>
                          {t('no_action')}
                        </span>
                      </td>
                      <td>Trip Guru</td>
                      <td onClick={() => this.openSummaryModal(index, completed)}>
                        {plan.planLocations.length ? plan.numDays + ' days in ' : ''}
                        {plan.planLocations.length
                          ? plan.planLocations.map((location, index) => {
                              if (index !== plan.planLocations.length - 1) {
                                return location.country + ', '
                              } else {
                                return location.country
                              }
                            })
                          : ''}
                      </td>
                      <td>
                        {plan.orderingUser ? plan.orderingUser.userProfile.firstName + ' ' + plan.orderingUser.userProfile.lastName : ''}
                      </td>
                      <td>{'$' + (plan.totalAmount + plan.servicesTotal)}</td>
                      <td>
                        {plan.startDate
                          ? this.props.i18n.t('date_format', {
                              date: plan.startDate
                            })
                          : ''}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <table className="table">
                <tbody>
                  <tr>
                    <td className="col-lg-2 col-md-2 col-sm-2 col-xs-2" />
                    <td className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                      <div className="arrow-wrapper">
                        <i className="icon-arrow-previous-1" onClick={() => this.goToTab(0)} />
                        <i className="icon-arrow-next-1" onClick={() => this.goToTab(1)} />
                      </div>
                    </td>
                    <td className="col-lg-1 col-md-1 col-sm-1" />
                    <td className="col-lg-3 col-md-3 col-sm-3" />
                    <td className="col-lg-2 col-md-2 col-sm-2" />
                    <td className="col-lg-1 col-md-1 col-sm-2" />
                    <td className="col-lg-1 col-md-1 col-sm-2" />
                  </tr>
                </tbody>
              </table>
            </div>
          </Tab>
        </Tabs>

        <Modal
          show={this.state.acceptOpen}
          onHide={() => this.closeModal()}
          id="accept"
          className="order-modal"
          aria-labelledby="ModalHeader"
        >
          <AcceptModal order={this.state.order} modalClose={() => this.closeModal()} />
        </Modal>

        <Modal
          show={this.state.summaryOpen}
          onHide={() => this.closeModal()}
          id="summary"
          className="order-modal"
          aria-labelledby="ModalHeader"
        >
          <SummaryModal order={this.state.order} modalClose={() => this.closeModal()} />
        </Modal>

        <Modal
          show={this.state.priceOpen}
          onHide={() => this.closeModal()}
          id="price"
          className="order-modal"
          aria-labelledby="ModalHeader"
        >
          <PriceModal order={this.state.order} modalClose={() => this.closeModal()} />
        </Modal>
      </div>
    )
  }
}

const enhance = compose(
  translate('orders'),
  graphql(CUSTOMIZED_PLAN_QUERY, {
    options: props => ({
      variables: {
        tripGuruId: props.user ? props.user.id : ''
      },
      fetchPolicy: 'network-only'
    })
  }),
  withRouter
)
export default enhance(TripGuruOrders)



// WEBPACK FOOTER //
// src/components/Guru/Orders/TripGuruOrders/index.jsx